import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { CountryCode } from './country.enum';
import { EmailPreferences } from './email-preferences.model';
import { FeatureFlags } from './feature-flag.model';

type AuthProvider = 'xero';

export interface User extends UserShared<firebase.firestore.Timestamp> {}
export interface UserAlgolia extends UserShared<Date> {}
export interface UserShared<T> {
  name: string;
  email: string;
  uid: string;
  mobile: string;
  agreedToTerms?: boolean;
  countryCode: CountryCode;
  /** @deprecated Deprecated on Aug 2020 - Admin users moved to their own collection */
  isAdmin?: boolean;

  // OAuth (xero) - Added Feb 2025
  connectedProviders?: AuthProvider[];

  // Added June 2025 - If true we show the profile completion page on app start
  profileIncomplete?: boolean;

  // Added April 2025
  featureFlags?: FeatureFlags;

  // Added July 2026 - Missing keys mean the email is enabled
  emailPreferences?: EmailPreferences;

  // Added Jan 2023
  companyName?: string;

  // Manually bought credits - these do not expire
  creditCount: number;
  creditsSpent: number;

  // Scheduled credits - these reset to autoTopUpCreditAmount every autoTopUpCreditFrequency
  scheduledTopUpCreditCount?: number;
  scheduledCreditsSpent?: number;
  scheduledTopUpCreditAmount?: number;
  scheduledTopUpCreditFrequency?: 'day' | 'week' | 'month';
  scheduledTopUpLastUpdatedDate?: T;

  totalConversions: number;
  registeredDate: T;
  lastConversionDate?: T;
  /** Allows us to limit visibility on admin system */
  isSensitive?: boolean;
  tags?: ('xero' | string)[];
  promotions?: {
    promotionUids: string[]; // This is to make Firestore queries possible
    details: { uid: string; code: string; credits: number; activatedDate: T }[];
  };
}
// Utils
export const getTotalCreditCount = (user: User | UserAlgolia) => {
  if (!user?.scheduledTopUpCreditCount) {
    return +(user?.creditCount || 0);
  }
  return +(user?.creditCount || 0) + +(user?.scheduledTopUpCreditCount || 0);
};
